function MoreOptionsIcon({ size = '18', style = {}, color = 'white' }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 3 18"
      fill="none"
    >
      <ellipse cx="1.5" cy="1.5" rx="1.5" ry="1.5" fill={color} />
      <circle cx="1.5" cy="9" r="1.5" fill={color} />
      <ellipse cx="1.5" cy="9" rx="1.5" ry="1.5" fill={color} />
      <circle cx="1.5" cy="16.5" r="1.5" fill={color} />
    </svg>
  );
}

export default MoreOptionsIcon;
